import type { ReactNode } from "react";
import styles from "./AdminPageIntro.module.css";

// The title + one-line summary at the top of every admin section, so each
// page reads at the same size and measure.

type AdminPageIntroProps = {
  readonly title: ReactNode;
  readonly children?: ReactNode;
  // Sits to the right of the title block (e.g. a selector or primary button).
  readonly aside?: ReactNode;
};

export const AdminPageIntro = ({ title, children, aside }: AdminPageIntroProps): JSX.Element => (
  <header className={styles.intro}>
    <div className={styles.text}>
      <h2 className={styles.title}>{title}</h2>
      {children !== undefined && <p className={styles.hint}>{children}</p>}
    </div>
    {aside !== undefined && <div className={styles.aside}>{aside}</div>}
  </header>
);
